export class TestExitSignal {}
